import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { BookingInfo, BookingsVM } from '@eroman/common/src/views/app/Bookings/BookingsVM';
import { BookingStatus } from '@eroman/common/src/models/bookings/BookingStatus';
import { SectionHeader } from '../../components/SectionHeader';
import { ScrollableList } from '../../components/ScrollableList';
import { Loader } from '../../components/Loader';
import { styles } from '../../styles';
import { BookingDetail } from '../AmenityInfo/BookingDetail';
import calendarIcon from '../Amenities/title-file.png';
import { AmenitiesInfoView } from '../AmenityInfo/AmenityInfoPresenter';
import AppContext from '../../lib/AppContext';
import { BookingsView } from './BookingsPresenter'; // Using existing icon as placeholder

export class BookingsPage extends React.Component implements BookingsView {
    private presenter = AppContext.presenters.bookingsPresenter(this);

    state = {
        model: new BookingsVM(),
    };

    modelChanged(model: any) {
        this.setState({ model });
    }

    async componentDidMount() {
        await this.presenter.start();
    }

    renderBookings = () => {
        if (this.state.model.bookings.length === 0) {
            return <NoBookings>No hay reservas para este amenity.</NoBookings>;
        }

        return (
            <_ScrollableList>
                {this.state.model.bookings.map(booking => (
                    <BookingItem key={booking.id}>
                        <BookingDetail 
                            booking={booking}
                            currentUnit=""
                            onCancel={() => {}}
                        />
                    </BookingItem>
                ))}
            </_ScrollableList>
        );
    };

    render() {
        return (
            <Container>
                <Box>
                    <Content>
                        <SectionHeader
                            icon={calendarIcon}
                            title={`Reservas realizadas`}
                        />
                        <AmenityInfo>
                           Amenity: {this.state.model.bookings.first()?.amenity}
                        </AmenityInfo>
                        {this.renderBookings()}
                    </Content>
                </Box>
            </Container>
        );
    }

}

const Container = styled.div`
    display: flex;
    justify-content: center;
    padding: 20px;
    min-height: 100vh;
    background-color: #f5f7fb;
`;

const Box = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 800px;
    border-radius: 20px;
    border: 1px solid rgba(146, 162, 196, 0.5);
    background-color: #FFFFFF;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;
    padding: 20px;
`;

const AmenityInfo = styled.div`
    margin: 10px 0 20px;
    padding: 10px;
    background-color: #f0f4ff;
    border-radius: 8px;
    font-size: ${styles.fonts.size.regular};
    color: #5F6B8C;
`;

const BookingItem = styled.div`
    margin-bottom: 10px;
    width: 100%;
`;

const NoBookings = styled.div`
    margin: auto;
    padding: 40px 0;
    text-align: center;
    font-size: ${styles.fonts.size.regular};
    color: #5F6B8C;
`;

const _ScrollableList = styled(ScrollableList)`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;